'use client';
import { CSSProperties, useContext } from 'react';
import { LogoContext } from '@web-libs/features/branding/logo/ui/logo.provider';
import TageaLogo from '@web-public/tagea-logo.svg';
import { TrmzFileImage } from '@web-libs/features/files/trmz-file/ui/trmz-file-image';
import { StaticTageaImage } from '@web-libs/ui/ui-components/media/static-tagea-image';
import { getCssVar } from '@web-libs/features/colors/application/colors';
import { useTageaRouter } from '@web-libs/core/routing/application/use-tagea-router.concern';
import Link from 'next/link';

export const Logo = ({
  withBackground,
  fitParent,
  fitHeight,
}: {
  withBackground?: boolean;
  fitParent?: boolean;
  fitHeight?: boolean;
}) => {
  const providedLogo = useContext(LogoContext);

  const alt = 'Das Logo des Trägers.';

  const _style: CSSProperties = {};

  if (withBackground) {
    _style.backgroundColor = getCssVar('light');
    _style.padding = 8;
    _style.borderRadius = 8;
  }

  const router = useTageaRouter();

  function buildImage() {
    if (!providedLogo) {
      return (
        <div style={{ height: 96 }}>
          <StaticTageaImage
            fitParent={true}
            height={96}
            style={_style}
            src={TageaLogo}
            alt={alt}
          />
        </div>
      );
    } else {
      return (
        <TrmzFileImage
          fitParent={fitParent}
          height={fitParent ? undefined : 96}
          style={_style}
          file={providedLogo}
          alt={alt}
        />
      );
    }
  }

  return <Link href={router.getLink('')}>{buildImage()}</Link>;
};
